import { Component, Input, inject } from '@angular/core';

import type { InfoboxButton } from '@core/components-infobox-legacy';
import { InfoboxComponent } from '@core/components-infobox-legacy';
import { I18nService, TranslatePipe } from '@core/i18n-legacy';

@Component({
  selector: 'rt-infobox-mailbox-error',
  templateUrl: './infobox-mailbox-error.component.html',
  styleUrls: ['./infobox-mailbox-error.component.less'],
  imports: [InfoboxComponent, TranslatePipe],
})
export class InfoboxMailboxErrorComponent {
  private readonly i18nService = inject(I18nService);

  @Input() public isDismissible: boolean;
  @Input() public storageKey: string;
  @Input() public showButtons: boolean = true;

  public buttons: InfoboxButton[] = [
    {
      text: this.i18nService.translate(
        'app.settings.admin_profile.mailbox_connection_error.go_to_settings',
      ),
      redirect: '#/settings/profile/email_settings',
      variant: 'outline-error',
    },
  ];
}
